import { render, staticRenderFns } from "./dux.vue?vue&type=template&id=a4c1f60c&scoped=true"
var script = {}
import style0 from "./dux.vue?vue&type=style&index=0&id=a4c1f60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c1f60c",
  null
  
)

export default component.exports